/**
 * @generated SignedSource<<fe65cdf45180ed007264b15af2616b96>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ParentCell448BadPattern$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "ParentCell448BadPattern";
};
export type ParentCell448BadPattern$key = {
  readonly " $data"?: ParentCell448BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"ParentCell448BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "ParentCell448BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "parent_issueFieldParentInlineEditFull_ParentInlineEditViewIsEditable_fragmentRef"
    }
  ],
  "type": "JiraParentIssueField"
};

(node as any).hash = "eb27fc4d9710436b849ffd33a2b305f2";

export default node;
